import React, { Component } from 'react';

import { Header, Navbar } from '@C';
import { MyProfileList } from '@C/CreditCustomerProfile/MyProfile';
import ErrorBoundary from '@C/Error';

class MyProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <main>
        <div className="page-wrapper">
          <Header title="Generate puchase order" />
          <Navbar />
          <div className="page-content">
            <section className="page-components">
              <ErrorBoundary>
                <MyProfileList />
              </ErrorBoundary>
            </section>
          </div>
        </div>
      </main>
    );
  }
}

export { MyProfile };
